
export default function (dom, opts) {
	let options = {

		singleNumberSel: '.figures__figure',
		showSingleNumber: 'figures__figure--show',
		reelSel: '.figures__reel',
		hideReelCls: 'figures__reel--hide',
		sectionSel: '.lead-section',
		runAnimationCls: 'figures__reel--run',
		...opts
	};

	const allNumbers = Array.from(dom.querySelectorAll(options.singleNumberSel));
	const numberReel = Array.from(dom.querySelectorAll(options.reelSel));

	function init() {
        replaceNumber()
	}

	function replaceNumber() {
		numberReel.forEach(n => {
			n.classList.add(options.runAnimationCls);
		});

		setTimeout(() => {
			numberReel.forEach(number => {
				number.classList.add(options.hideReelCls);
			});
			allNumbers.forEach(all => {
				all.classList.add(options.showSingleNumber);
			})

		}, 1000);
	}

	init()

}
